import moment from 'moment';

export function idToDate(id?: string | null) {
  return new Date(1000 * parseInt(id ? id.substr(0, 8) : '', 16));
}

export const getElapsedDaysFromId = (id: string): number => {
  const start = moment(idToDate(id));
  const now = moment(Date.now());

  return now.diff(start, 'days');
};
